import React, { FC } from 'react';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';

// antd's success / warning tokens — the green and yellow status dots.
const ACTIVE_COLOR = '#52c41a';
const INVITED_COLOR = '#faad14';

const MemberCount: FC<{ count: number; color: string; label: string }> = ({
	count,
	color,
	label,
}) => (
	<span className="flex items-center gap-2 whitespace-nowrap">
		<span
			className="inline-block h-2 w-2 flex-shrink-0 rounded-full"
			style={{ backgroundColor: color }}
		/>
		<span className="bodyregular text-character-primary">{count}</span>
		<span className="footnoteregular text-character-secondary">{label}</span>
	</span>
);

// Member counts, both server-derived: the service hydrates them from each member's account
// status on the list and the single-GET alike, so nothing is aggregated here.
//
// The split is active vs **invited**, not active vs inactive — `ContactStatus` only yields
// those two for group members, so "invited" is what the yellow dot honestly represents.
const UserGroupMemberCounts: FC<any> = ({ record }): React.ReactElement => (
	<div className="flex items-center gap-6">
		<MemberCount
			count={nullSafeGetOrElse('activeUsersCount', record, 0)}
			color={ACTIVE_COLOR}
			label="active"
		/>
		<MemberCount
			count={nullSafeGetOrElse('invitedUsersCount', record, 0)}
			color={INVITED_COLOR}
			label="invited"
		/>
	</div>
);

export default UserGroupMemberCounts;
